onInteractive(function() {
	// Header photos are cropped to fill their box, so the browser needs the rendered width of the whole photo to pick a sharp source.
	// Event cards on the overview have no sizes hint of their own either, so they get their real rendered width.
	const pictures = document.querySelectorAll('.home-hero picture, .page-header picture, .blog-item-preview-image picture');
	const updateSizes = function() {
		pictures.forEach(function(picture) {
			const image = picture.querySelector('img');
			if (!image || !image.getAttribute('width') || !image.getAttribute('height')) {
				return;
			}
			const box = image.getBoundingClientRect();
			if (!box.width) {
				return;
			}
			const ratio = image.getAttribute('width') / image.getAttribute('height');
			const width = Math.ceil(Math.max(box.width, box.height * ratio));
			picture.querySelectorAll('source, img').forEach(function(element) {
				element.setAttribute('sizes', width + 'px');
			});
		});
	};
	updateSizes();
	window.addEventListener('resize', updateSizes);
});

onInteractive(function() {
	// The shield hangs below the menu bar at the top of the page; once the visitor scrolls it shrinks
	// into the bar so it does not cover the content. The bar keeps its height, so nothing jumps.
	const header = document.querySelector('.nav-header');
	if (!header) {
		return;
	}
	const updateScrolled = function() {
		header.classList.toggle('nav-header-scrolled', window.scrollY > 40);
	};
	updateScrolled();
	window.addEventListener('scroll', updateScrolled, { passive: true });
});
